export default "__VITE_ASSET__N6i49WWa__"